const toFlatArray = <T extends Record<string, any>>(data: T[], childrenKey: string, result: T[] = []): T[] => {
  if (!data?.length) {
    return result;
  }

  const nextData: T[] = [];

  data.forEach(({ [childrenKey]: children, ...nestedData }: T) => {
    result.push({ ...nestedData, [childrenKey]: [] } as T);

    if (!children?.length) {
      return;
    }

    nextData.push(...children);
  });

  return toFlatArray(nextData, childrenKey, result);
};

export default toFlatArray;
